import type { HomeListingDetails } from './home';

export function Download(this: HomeListingDetails): string {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- This is a guard clause to ensure that the listing is defined before proceeding with the download logic. If the listing is not defined, it returns an empty string.
  if (!this.listing()) {
    return '';
  }

  if (this.listing().saleType === 'new') {
    return this.listing().floorPlan ?? '';
  } else if (this.listing().saleType === 'preowned') {
    return this.listing().flyerUrl ?? '';
  }

  return '';
}
